import BoardSaledReportsBroker from './components/boardsalesreportsbroker/boardsaledreportsbroker.vue'
import SearchSalesReportBroker from './components/searchsalesreportbroker/searchsalesreportbroker.vue'
import salesreportsbrokeForm from './salesreportsbroke-form'
import PermissionMixin from '@/store/module/permission/mixin'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import Roles from '@/shared/utils/roles.js'
import tablesalereportmonth from './components/tablesalereportmonth/tablesalereportmonth.vue'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'SalesReportsBroker',
  mixins: [ PermissionMixin ],
  components: {
    BoardSaledReportsBroker,
    SearchSalesReportBroker,
    tablesalereportmonth,
    reportEnterprise: []
  },
  data () {
    return {
      meses: ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'],
      columns: ['EMPRRENDIMENTO', 'VALOR', 'QUANTIITEM', 'DATA'],
      haveData: true,
      form: salesreportsbrokeForm,
      datasearch: [],
      reportEnterprise: [],
      roles: Roles,
      allSales: [],
      currentyMonth: new Date().getMonth(),
      onlyTable: false,
      customDate: false,
      hasData: false,
      containerImgReportClass: 'container-img-reports invisible',
      containerBoards: 1
    }
  },
  methods: {
    search (objSearch, limparFiltro) {
      this.reportEnterprise = []
      this.containerBoards++
      loading.push()
      if (limparFiltro === true) {
        let now = new Date()
        let firstDay = new Date(now.getFullYear(), 0, 1)
        let lastDay = new Date(now.getFullYear(), 11, 31)
        objSearch.DtFinal = lastDay
        objSearch.DtInicial = firstDay
      }
      ProposalRepository.GetRelatorioCorretor(objSearch)
        .then(Response => {
          if (limparFiltro === true) {
            localStoreHelper.imobiliaria.relatorioVendasCorretor(null)
          }
          loading.pop()
          this.hasData = (Response.data.data.length > 0)
          if (!this.hasData) {
            this.containerImgReportClass = this.containerImgReportClass.replace('invisible', '')
          } else {
            if (!this.containerImgReportClass.includes('invisible', '')) {
              this.containerImgReportClass = this.containerImgReportClass + ' invisible'
            }
          }
          if (this.onlyTable) {
            let dataSales = Response.data.data
            let enterpriseNames = []
            dataSales.forEach(sale => {
              if (!enterpriseNames.includes(sale.nomeEmpreendimento)) {
                enterpriseNames.push(sale.nomeEmpreendimento)
              }
            })
            enterpriseNames.forEach(enterpriseName => {
              this.reportEnterprise.push(
                dataSales.filter(sale => sale.nomeEmpreendimento === enterpriseName)
              )
            })
            return
          }
          this.allSales = Response.data.data
        })
    },
    filterByMonth (month) {
      return this.allSales.filter(report => report.mes === month)
    },
    setSearch (newValue) {
      this.onlyTable = newValue
    },
    setCustomDate (newValue) {
      this.customDate = newValue
    },
    getDataSales (posicaoMes) {
      this.$refs.BoardSale[posicaoMes].SetDataSales(this.filterByMonth(posicaoMes))
    }
  },
  mounted () {
    const now = new Date()
    const firstDay = new Date(now.getFullYear(), 0, 1)
    const lastDay = new Date(now.getFullYear(), 11, 31)
    if (localStoreHelper.imobiliaria.relatorioVendasCorretor() != null) {
      this.search(localStoreHelper.imobiliaria.relatorioVendasCorretor())
      this.setSearch(true)
    } else {
      let objSearch = {
        DtFinal: lastDay,
        DtInicial: firstDay
      }
      ProposalRepository.GetRelatorioCorretor(objSearch)
        .then(Response => {
          this.hasData = (Response.data.data.length > 0)
          localStoreHelper.imobiliaria.relatorioVendasCorretor(null)
          if (!this.hasData) {
            this.containerImgReportClass = this.containerImgReportClass.replace('invisible', '')
          } else {
            if (!this.containerImgReportClass.includes('invisible', '')) {
              this.containerImgReportClass = this.containerImgReportClass + ' invisible'
            }
          }
          this.allSales = Response.data.data
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesreportsbroker/salesreportsbroker.js